import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getQuizPhaseThunk,
  startQuizThunk,
  getVideoTutorialInicioQuizThunk,
} from "../../store/quiz/quiz.thunks";
import { useEffect } from "react";
import { resetQuizState } from "../../store/quiz/quiz.slice";
import { toast } from "react-toastify";
import { isTutorialVisto } from "../../utils/tutorialWatched";

const TIPO_INICIO_QUIZ = "inicio_quiz";

const HeroRight = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const userId = user?.user_id || user?.id;

  const { phase, sessionId, videoTutorial } = useSelector((state) => state.quiz);

  useEffect(() => {
    dispatch(getQuizPhaseThunk());
    dispatch(getVideoTutorialInicioQuizThunk());
  }, [dispatch]);

  // Redirigir automáticamente a la página de talentos si el quiz está completado
  useEffect(() => {
    if (phase === "completada") {
      navigate("/mis-talentos");
    }
  }, [phase, navigate]);

  // Intenta abrir pantalla completa de forma no bloqueante.
  // iOS Safari no soporta fullscreen sobre <html> (solo sobre <video> con
  // webkitEnterFullscreen), así que si no está disponible o falla, seguimos.
  const enterFullscreenSafe = async (element) => {
    if (!element) return;
    const pedir =
      element.requestFullscreen ||
      element.webkitRequestFullscreen ||
      element.msRequestFullscreen;
    if (!pedir) return;
    try {
      await pedir.call(element);
    } catch (err) {
      console.warn("Fullscreen no disponible:", err);
    }
  };

  const handleClick = async () => {
    if (!navigator.onLine) {
      toast.error("No tienes conexión a internet");
      return;
    }

    // Chequeo de tutoriales vistos según los videos configurados para el
    // inicio del quiz. Si no ha visto los pendientes → mensaje y a /tutorial-video.
    const tieneTutorial = Boolean(
      videoTutorial?.tutorial?.tiene_video ||
        videoTutorial?.tiene_video,
    );
    const tieneInstrucciones = Boolean(
      videoTutorial?.instrucciones?.tiene_video,
    );
    const kindsRequeridos = [];
    if (tieneTutorial) kindsRequeridos.push("tutorial");
    if (tieneInstrucciones) kindsRequeridos.push("instrucciones");

    const pendientes = kindsRequeridos.filter(
      (k) => !isTutorialVisto(userId, TIPO_INICIO_QUIZ, k),
    );

    if (pendientes.length > 0) {
      toast.warning("Primero debes ver el tutorial antes de comenzar.");
      navigate("/tutorial-video");
      return;
    }

    // Fullscreen opcional — usar helper con soporte a webkit/ms/iOS.
    if (!document.fullscreenElement) {
      await enterFullscreenSafe(document.documentElement);
    }

    if (phase === "en_progreso" && sessionId) {
      navigate("/test-quiz");
    } else {
      // LIMPIAR ESTADO ANTES DE CREAR NUEVO QUIZ
      dispatch(resetQuizState());

      const result = await dispatch(startQuizThunk());

      if (result.meta.requestStatus === "fulfilled") {
        navigate("/test-quiz");
      }
    }
  };

  const isContinuing = phase === "en_progreso";

  return (
    <div className="hero-text-wrapper">
      <h1 className="hero-title">BIENVENIDO {user.nombre_completo}</h1>

      <h4 className="hero-subtitle">
        {isContinuing
          ? "Tienes un test en progreso"
          : "Tienes un test que contestar"}
      </h4>

      <div className="hero-buttons mt-4">
        <button
          className={`btn mt-4 ${
            isContinuing ? "hero-btn-continue" : "hero-btn-urgent"
          }`}
          onClick={handleClick}
        >
          <Icon
            icon={isContinuing ? "solar:play-bold" : "solar:bolt-bold"}
            className="me-2 hero-btn-icon"
          />

          {isContinuing ? "Continuar test" : "Comenzar ahora"}
        </button>
        <button
          className="hero-btn-tutorial"
          onClick={() => navigate("/tutorial-video")}
        >
          <Icon icon="solar:book-2-bold" className="me-2 hero-btn-icon" />
          Ver tutorial
        </button>
      </div>
    </div>
  );
};

export default HeroRight;
